//PDF预览

import jsPreviewDocx from "@js-preview/docx";
import jsPreviewPdf from "@js-preview/pdf";
import { useEffect, useState } from 'react';
import { URL_file_downloadFile } from "./Utils/UrlUtils";
import './PdfPreviewerShow.css'
export default () => {

  let fileSuffix: any
  let token: any
  let id: any
  let thisUrl = window.location.toString()
  let params = thisUrl.split('?')[1]//参数值
  params.split('&').map((str) => {
    let key = str.split('=')[0].trim()
    let value = str.split('=')[1].trim()
    if (key == 'id') id = value
    else if (key == 'token') token = value
    else if (key == 'fileSuffix') fileSuffix = value
  })
  // console.log('id == ' + id)
  // console.log('token == ' + token)
  // console.log('fileSuffix == ' + fileSuffix)
  useEffect(() => {
    getPreviewUrl()
  }, []);

  const getPreviewUrl = async () => {
    if (fileSuffix === '.docx' || fileSuffix === '.doc') {
      var docxView: any = document.getElementById('ony-show-word-view')
      var myDocxPreviewer = jsPreviewDocx.init(docxView)
      myDocxPreviewer.setOptions({
        inWrapper: true,
        // ignoreWidth: true,
        // ignoreHeight: true,
        ignoreFonts: true,
        breakPages: true,
        debug: true,
        experimental: true,
        trimXmlDeclaration: true,
        renderHeaders: false,
        renderFooters: false,
        renderFootnotes: true,
        renderEndnotes: true,
        ignoreLastRenderedPageBreak: true,
        useBase64URL: true,
        useMathMLPolyfill: true,
        renderChanges: true,
      })
      myDocxPreviewer.setRequestOptions({
        method: 'GET', // 请求类型为 GET
        headers: { // 设置 header
          'Authorization': 'Xyxyzka ' + token // Authorization 字段包含身份验证令牌
        }
      })
      await myDocxPreviewer?.preview(URL_file_downloadFile + '?id=' + id)
        .then((res: any) => {
          console.log('预览完成');
          previewSuccess()
        })
        .catch((e: any) => {
          console.log('预览失败', e);
          setLoadingStr('预览失败')
        });
    } else if (fileSuffix === '.pdf') {
      var pdfView: any = document.getElementById('ony-show-pdf-view')
      var myPdfPreviewer = jsPreviewPdf.init(pdfView)

      let url = URL_file_downloadFile + '?id=' + id
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      //设置请求头参数的方式,如果没有可忽略此行代码
      xhr.setRequestHeader("Authorization", `Xyxyzka ${token}`)
      //设置响应类型为 blob   xhr.open必须为 异步
      xhr.responseType = 'blob';
      //关键部分
      xhr.onload = function (e) {
        //如果请求执行成功
        if (this.status == 200) {
          let blob = this.response;
          myPdfPreviewer?.preview(blob)
            .then((res: any) => {
              console.log('预览完成');
            })
            .catch((e: any) => {
              // debugger
              console.log('预览失败', e);

            });
        }
      }
      xhr.send()
    }
  }

  // const [wordWidth, setWordWidth] = useState<any>()
  const [wordZoom, setWordZoom] = useState<number>()
  const windowWidth = window.screen.width

  const [showWord, setShowWord] = useState<boolean>(false)
  const [loadingStr, setLoadingStr] = useState<string>('数据加载中...')
  const previewSuccess = () => {
    //word 预览成功 排版设置
    let docxView = document.getElementsByClassName('docx')
    let wordWidth = docxView[0]?.clientWidth //word实际的宽度
    let zoom = windowWidth / wordWidth  //计算缩放比例

    // setWordWidth(wordWidth)
    setWordZoom(zoom)

    setTimeout(() => {
      setLoadingStr('预览完成')
      setShowWord(true);
    }, 500);
  }
  return (<>
    {/* <div>word宽度 = {wordWidth}</div> */}
    {/* <div>浏览器宽度 = {windowWidth}</div> */}
    {/* <div>zoom大小 = {wordZoom}</div> */}

    <div style={{ textAlign: 'center', marginTop: '20px', display: showWord ? 'none' : 'block' }}>{loadingStr}</div>
    <div style={{ visibility: showWord ? 'visible' : 'hidden' }}>
      <div id="ony-show-pdf-view" style={{ width: '100%', height: '100%', overflow: 'auto' }} ></div>
      <div id="ony-show-word-view" style={{ zoom: wordZoom }}></div>
    </div>

  </>
  )

}
